<template>
  <global-modal :active="dialog.isActive" @toggleActive="toggleActive">
    <!-- Header -->
    <section class="text-xl font-medium" slot="header">Disposisi Surat</section>

    <!-- Body -->
    <section class="p-5">
      <!-- Disposition Type -->
      <div class="flex justify-center w-full" v-if="!formValues.target">
        <div
          v-for="(item, index) in target"
          class="flex justify-center items-center cursor-pointer"
          :key="index"
        >
          <vs-button
            v-if="item.isShow"
            :color="item.color"
            :icon="item.icon"
            class="mx-2"
            :type="item.type || 'border'"
            icon-pack="feather"
            @click="() => (formValues.target = item.value)"
          >
            {{ item.label }}
          </vs-button>
        </div>
      </div>

      <!-- Form -->
      <form v-else>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <div v-if="formValues.target">
              <!-- User Target -->
              <label>Disposisi Ke</label>
              <vs-select
                :options="disposisiUser"
                class="w-full"
                label-placeholder="Pengguna"
                label="nama"
                v-model="formValues.selectedDisposition"
              />

              <!-- Note -->
              <div class="mt-4">
                <label for="keterangan">Keterangan</label>
                <quill-editor v-model="formValues.keterangan" />
              </div>

              <!-- Paraf -->
              <vs-checkbox v-if="$sanctum.canParafDisposition() && formValues.target == 'acc'" 
                class="pt-4" 
                v-model="formValues.isParaf"
              >
                Paraf Persetujuan Surat
              </vs-checkbox>

              <!-- Checkboxes -->
              <!-- <div v-if="$user.isHeadPosition">
                <vs-checkbox class="pt-4" v-model="formValues.isArsip">
                  Arsipkan
                </vs-checkbox>
                <vs-checkbox class="pt-4" v-model="formValues.isAgenda">
                  Agendakan
                </vs-checkbox>
                <vs-checkbox class="pt-4" v-model="formValues.isTugaskan">
                  Tugaskan
                </vs-checkbox>
                <vs-checkbox class="pt-4" v-model="formValues.isAccProses">
                  Acc Proses
                </vs-checkbox>
                <vs-checkbox class="pt-4" v-model="formValues.isRevisi">
                  Revisi
                </vs-checkbox>
              </div> -->
            </div>
          </div>
        </div>
      </form>
    </section>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div v-if="formValues.target">
        <vs-button
          class="mr-2"
          color="primary"
          type="filled"
          :disabled="!isFormValid()"
          @click="handleOnSubmit"
        >
          Disposisi
        </vs-button>
        <vs-button color="danger" type="border" @click="toggleActive(false)">
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import VsSelect from "vue-select";
import QuillEditor from "./QuillEditor";

import {
  GET_COUNT_JABATAN_DISPOSISI,
  GET_USER_BY_DISPOSISI_JABATAN
} from "@/query/jabatan";
import { POST as POST_DISPOSITION } from "@/query/disposisi";
import { STATUS_DRAFT, STATUS_ACCEPT } from "@/const/surat";
import { store as storeNotification } from "@/firebase/notification";

export default {
  components: {
    QuillEditor,
    VsSelect
  },
  props: {
    surat: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      dialog: {
        isActive: false
      },
      formValues: {
        target: null,
        selectedDisposition: null,
        keterangan: null,
        isArsip: false,
        isAgenda: false,
        isTugaskan: false,
        isAccProses: false,
        isRevisi: false,
        isParaf: false
      },
      listUserByDisposisi: [],
      paraf: this.$sanctum.canParafDisposition(),
    };
  },

  apollo: {
    jabatanCount: {
      query: GET_COUNT_JABATAN_DISPOSISI,
      update: data => data.penggunaGetTargetDisposisiCount,
      variables() {
        return {
          userId: this.$user.id
        };
      },
      fetchPolicy: "cache-and-network"
    },
    disposisiUser: {
      query: GET_USER_BY_DISPOSISI_JABATAN,
      update: data => {
        return data.penggunaGetByJabatanDisposisi.data
      },
      variables() {
        return {
          perPage: 10000,
          userId: this.$user.id,
          disposisiJabatan: this.targetDisposition
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    target() {
      if (!this.jabatanCount) return [];
      return [
        {
          label: "Acc",
          color: "primary",
          icon: "icon-check",
          type: "filled",
          value: "acc",
          isShow: this.$user.isHeadPosition
        },
        {
          label: "Revisi",
          color: "warning",
          icon: "icon-edit",
          value: "revision",
          isShow: this.$user.isHeadPosition
        },
        {
          label: "Naik",
          color: "primary",
          icon: "icon-arrow-up",
          value: "up",
          isShow: Boolean(this.jabatanCount.atasanCount)
        },
        {
          label: "Turun",
          color: "success",
          icon: "icon-arrow-down",
          value: "down",
          isShow:
            Boolean(this.jabatanCount.bawahanCount) &&
            !this.$user.isHeadPosition
        },
        {
          label: "Samping",
          color: "warning",
          icon: "icon-arrow-right",
          value: "parallel",
          isShow:
            Boolean(this.jabatanCount.sejajarCount) &&
            this.$user.canParallelDisposition
        }
      ];
    },
    targetDisposition() {
      switch (this.formValues.target) {
        case "acc":
          return "down";
        case "revision":
          return "down";
        default:
          return this.formValues.target || "up";
      }
    }
  },
  watch: {
    "formValues.target"() {
      this.formValues.selectedDisposition = null;
    },
    disposisiUser: {
      handler(){
        this.setListDisposisiUser()
      }
    }
  },

  mounted(){
    this.setListUserByDisposisi();
  },

  methods: {
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
      this.resetFormValues();
    },

    setListUserByDisposisi(){
      this.surat.disposisi.map((item) => {
        let check = this.listUserByDisposisi.some(i => i.id === item.pengguna.id);
        if(!check){
          this.listUserByDisposisi.push({
            id: item.pengguna.id, 
            nama: item.pengguna.nama, 
            urutan: parseInt(item.pengguna.jabatan.id)
          });
        }
      });

      this.listUserByDisposisi.sort(function(a, b){
        return a.urutan - b.urutan;
      });

      this.listUserByDisposisi.map((item, key) => {
        delete this.listUserByDisposisi[key].urutan;
      });
    },

    setListDisposisiUser(){
      if(this.$user.role == 'kepala_opd' && this.surat.tipe == 'surat_keluar'){
        this.disposisiUser = this.listUserByDisposisi;
      }
    },

    isFormValid() {
      const form = this.formValues;
      return form.target && form.selectedDisposition;
    },

    async handleOnSubmit() {
      try {
        await this.submit();
        this.toggleActive(false);
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Disposisi surat sukses"
        });
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: "danger",
          title: "Sukses",
          text: "Disposisi surat gagal"
        });
      }
    },

    async submit() {
      let mutationData = this.getMutationInput();
      await this.$apollo.mutate({
        mutation: POST_DISPOSITION,
        variables: {
          input: mutationData
        },
        update: () => this.submitCallback(mutationData)
      });
    },

    submitCallback(mutationData) {
      this.$emit("submitCallback");
      this.sendNotification(mutationData);
    },

    sendNotification(mutationData){
      let data = {
        except_login_id : this.$sanctum.getUser().login_id,
        pengguna_id : mutationData.ke_pengguna,
        pengguna_list : null,
        judul : 'Notifikasi Surat',
        konten : `Terdapat disposisi surat ${this.surat.index} kepada anda.`,
        halaman : 'surat-lihat',
        notifikasiable_id : this.surat.id,
        notifikasiable_uuid : this.surat.uuid,
        ikon : 'MailIcon'
      }
      storeNotification(data);
    },

    getMutationInput() {
      const form = this.formValues;

      // Last disposition Id
      const lastDispositionId = this.surat.lastDisposition
        ? this.surat.lastDisposition.id
        : null;
      const userId = form.selectedDisposition
        ? form.selectedDisposition.id
        : null;

      let status = STATUS_DRAFT;
      if (this.surat.status == "acc") status = STATUS_ACCEPT; // status tetap acc jika
      if (this.formValues.target == "acc") status = STATUS_ACCEPT;

      let note = form.keterangan;
      let paraf = this.$sanctum.canParafDisposition() ? form.isParaf : null;

      // di comment karena fitur checkbox dikadis di hilangkan sementara
      // if (form.isArsip) note += "<br> Diarsipkan";
      // if (form.isAgenda) note += "<br> Diagendakan";
      // if (form.isTugaskan) note += "<br> Ditugaskan";
      // if (form.isAccProses) {
      //   note += "<br> Acc Proses";
      //   status = STATUS_ACCEPT;
      // }
      // if (form.isRevisi) note += "<br> Revisi";

      // Mutation Input
      return {
        ke_pengguna: userId,
        keterangan: note || "-",
        surat_id: this.surat.id,
        disposisi_sebelumnya: lastDispositionId,
        tipe: form.target,
        pengguna_id: this.$user.id,
        paraf: paraf,
        surat: {
          update: {
            id: this.surat.id,
            disposisi_terakhir_pengguna_id: userId,
            status
          }
        }
      };
    },

    resetFormValues() {
      this.formValues = {
        target: null,
        selectedDisposition: null,
        keterangan: null,
        isArsip: false,
        isAgenda: false,
        isTugaskan: false,
        isAccProses: false,
        isRevisi: false
      };
    }
  }
};
</script>
